<template>
  <div class="component-background-desktop component-background-mobile">
    <Heading :title="title" :class="headingClasses" />
    <div class="pt-4 xl:px-[15vw]">
      <button @click="goBack"
        class="back-sm hover:text-blue-600 hover:underline text-sm text-[#2E59FF] pb-6">Voltar</button>
    </div>
    <form class="px-2.5 pt-[22px] grid gap-y-4 xl:px-[15vw]">
      <p class="text-[16px] pb-[18px] text-black">Sugestões? Fale conosco!</p>
      <div>
        <LabelContactForm :class="initialValueFindUser().name ? 'text-gray-500' : ''" text="Nome" for="name"
          :require="!initialValueFindUser().name" />
        <Input placeholder="João da Silva" name="name" v-model="form.name"
          :class="initialValueFindUser().name ? '!border-transparent !bg-gray-400' : ''"
          :disabled="initialValueFindUser().name" />
      </div>
      <div>
        <LabelContactForm :class="initialValueFindUser().name ? 'text-gray-500' : ''" text="Email" for="email"
          :require="!initialValue().email" />
        <Input placeholder="joao@email.com" name="email" v-model="form.email"
          :class="initialValue().email ? '!border-transparent !bg-gray-400' : ''" :disabled="initialValue().email" />
      </div>
      <div>
        <LabelContactForm class="text-black" for="assunto" text="Assunto" :require="true" />
        <Input placeholder="Sugestão" name="mobile" v-model="form.subtitle" disabled/>
        <!-- <Select :modelValue="modelValue" :placeholder="placeholder" :options="options" class="mb-6 !w-full border-2" v-model="form.subtitle"/> -->
      </div>

      <div>
        <LabelContactForm class="text-black" for="descricao" text="Descrição" :require="true" />
        <TextArea placeholder="Escreva sua sugestão..." v-model="form.text" maxlength="800" class="h-[261px]" />
        <div class="flex justify-end">
          <span class="text-[12px] text-gray-600">{{ form.text.length }}/800 caracteres</span>
        </div>
      </div>

      <Button @click.prevent="submit" class="my-9">
        <p class="text-xl">
          Enviar
        </p>
      </Button>

      <p class="mb-4 text-gray-600"><span class="text-red-700">*</span> Campo obrigatórios.</p>

      <p class="mb-14 text-gray-600">
        A proteção de dados é a nossa prioridade. Para obter mais informações
        sobre como trataremos seus dados,
        <a class="underline text-[#2E59FF]" href="privacy">clique aqui</a> para
        acessar nossa Política de Privacidade.
      </p>
    </form>
    <transition>
      <div v-if="showModal" class="
          fixed
          right-0
          left-0
          top-0
          bottom-0
          z-[99]
          bg-[#707070]
          bg-opacity-40
          flex
          justify-center
          items-center
        ">
        <div class="
            bg-white
            border-[1px] border-primary
            rounded-[4px]
            mx-2.5
            w-full
            pl-4
            pr-2
            pt-2
            pb-2
            leading-9
            max-w-[286px]
          ">
          <button class="float-right" @click="showModal = false">
            <Icon name="Fechar" />
          </button>
          <h1 class="text-[20px] font-bold text-primary">Sugestão Enviada</h1>
          <p class="text-[16px] leading-6">Iremos analisar as possibilidades e se for viável implementaremos a sua ideia na plataforma!</p>
          <p class="text-[16px] leading-8">Agradecemos sua participação!</p>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import Heading from "@/Components/UI/Texts/Heading.vue";
import LabelContactForm from "@/Components/LabelContactForm.vue";
import Input from "@/Components/UI/Form/InputWithoutIcon.vue";
import InputLabelContactForm from "@/Components/InputLabel.vue";
import Select from "@/Components/UI/Form/Select.vue";
import TextArea from "@/Components/TextAreaContact.vue";
import ButtonContactForm from "@/Components/ButtonContactForm.vue";
import Icon from "@/Components/UI/Icons/Icon.vue";
import { formatPhoneNumber } from "@/Helpers/masks";
import Button from "@/Components/Button.vue";

export default {
  components: {
    TextArea,
    Heading,
    LabelContactForm,
    InputLabelContactForm,
    Select,
    TextArea,
    ButtonContactForm,
    Icon,
    Input,
    Button
  },
  data() {
    return {
      modelValue: "Assunto",
      placeholder: "Sugestão",
      text: "",
      showModal: false,
      form: this.$inertia.form({
        name: this.initialValueFindUser().name,
        email: this.initialValue().email,
        mobile: this.initialValueFindUser().mobile,
        subtitle: "Sugestão",
        text: "",
      }),
    };
  },
  computed: {
    charactersRemaining: function () {
      return this.text.length;
    },
  },
  props: {
    title: String,
    headingClasses: String
  },
  methods: {
    submit() {
      // this.showModal = true;
      console.log(this.form);
      this.$inertia.post("/contact-form/sugest", this.form, {
        onSuccess: () => {
          this.showModal = true
          this.form.subtitle = ''
          this.form.text = ''
        }
      });
    },
    formatPhoneNumber,
    initialValueFindUser() {
      if (this.$page.props[0]) {
        return this.$page.props[0].data;
      } else {
        return "";
      }
    },
    initialValue() {
      if (this.$page.props.auth.user) {
        return this.$page.props.auth.user;
      } else {
        return "";
      }
    },
    goBack() {
      return window.history.go(-1);
    },
  },
};
</script>
  